import React from "react";
import "./Footer.css";
import { Wave } from "../Wave/Wave";
import { useLocation } from "react-router-dom";
import { waMessages } from "../../Utils/waMessages";
import logo from "../../images/logo_white_full.png";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";

export const Footer = () => {
  const isActivitiesPage = useLocation().pathname === "/activities";

  return (
    <>
      {!isActivitiesPage && <Wave />}
      <footer
        className="footer"
        style={{ paddingTop: isActivitiesPage ? "40px" : "0px" }}
      >
        <div className="footer__container">
          <div className="footer__left">
            <img src={logo} alt="Treecard Logo" className="footer__logo" />
            <div className="footer__left__text">
              <p className="footer__copyright">Copyright © 2025</p>
              <p className="footer__tagline">
                The best surfer out there is
                <br />
                the one having the most fun.
              </p>
            </div>
          </div>

          <div className="footer__center" />

          <div className="footer__right">
            <div className="footer__socials">
              <a
                href="https://www.instagram.com/tide_surfpuertoescondido/"
                rel="noopener noreferrer"
                aria-label="Instagram"
                target="_blank"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href={`https://wa.me/529541686583?text=${waMessages.general}`}
                rel="noopener noreferrer"
                aria-label="Whatsapp"
                target="_blank"
              >
                <FaWhatsapp size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer__developer">
          <p>
            Developed by <a href="https://www.upmint.co">UpMint</a>.
          </p>
        </div>
      </footer>
    </>
  );
};
